var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGradientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8746 1.92578H1.12458C1.03619 1.92578 0.963867 1.9981 0.963867 2.0865V3.37221C0.963867 3.4606 1.03619 3.53292 1.12458 3.53292H16.8746C16.963 3.53292 17.0353 3.4606 17.0353 3.37221V2.0865C17.0353 1.9981 16.963 1.92578 16.8746 1.92578ZM16.8746 14.4615H1.12458C1.03619 14.4615 0.963867 14.5338 0.963867 14.6222V15.9079C0.963867 15.9963 1.03619 16.0686 1.12458 16.0686H16.8746C16.963 16.0686 17.0353 15.9963 17.0353 15.9079V14.6222C17.0353 14.5338 16.963 14.4615 16.8746 14.4615ZM16.8746 8.19364H1.12458C1.03619 8.19364 0.963867 8.26596 0.963867 8.35435V9.64007C0.963867 9.72846 1.03619 9.80078 1.12458 9.80078H16.8746C16.963 9.80078 17.0353 9.72846 17.0353 9.64007V8.35435C17.0353 8.26596 16.963 8.19364 16.8746 8.19364Z",
    fill: "url(#paint0_linear_2813_57507)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2813_57507",
    x1: 16.2985,
    y1: 14.2923,
    x2: 1.42227,
    y2: 14.4774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGradientIcon);
export default __webpack_public_path__ + "static/media/menu-gradient-icon.36954e79dcb1dff530f310dac02796d8.svg";
export { ForwardRef as ReactComponent };